import { GroupsView } from "./_components";

export default function GroupsPage() {
  return <GroupsView />;
}
